import { render, staticRenderFns } from "./LibrariesManagement.vue?vue&type=template&id=79008076&scoped=true&"
import script from "./LibrariesManagement.vue?vue&type=script&lang=ts&"
export * from "./LibrariesManagement.vue?vue&type=script&lang=ts&"
import style0 from "./LibrariesManagement.vue?vue&type=style&index=0&id=79008076&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79008076",
  null
  
)

export default component.exports